import { httpAll } from "../../httpAll";
import { _Base } from "../_Base";

export class EmailDailyReport extends _Base {
  preSend(params: { additionalCookies: any; debug?: boolean }) {
    const root = process.env.REACT_APP_ROOT_T_API;
    const urlV1 = root + "daily-report/v1.0/overview";
    const urlV2 = root + "daily-report/v2.0/overview";
    var requestV1 = this.preparePost(urlV1, params, null);
    var requestV2 = this.preparePost(urlV2, params, null);
    const requests = {
      v1: requestV1,
      v2: requestV2,
    };
    return httpAll(requests);
  }

  send(params: { subject: string; message: string; debug: boolean }) {
    const root = process.env.REACT_APP_ROOT_T_API;
    const urlV1 = root + "daily-report/v1.0/email";
    const urlV2 = root + "daily-report/v2.0/email";
    const headers = {
      "Content-Type": "application/json",
    };
    const requestV1 = this.preparePost(urlV1, params, headers);
    const requestV2 = this.preparePost(urlV2, params, headers);
    return httpAll({ v1: requestV1, v2: requestV2 });
  }

  getAccounts() {
    const endPointRoot = process.env.REACT_APP_ROOT_T_REST;
    let url = endPointRoot + "/user/search";
    const params = {
      filters: [
        {
          dimension: "active",
          segments: [true],
        },
        // {
        //   dimension: "level",
        //   segments: ["SUBSCRIBER", "TRIAL", "INTERNAL", "LEAD", "FREE"],
        // },
      ],
      sort: {
        dimension: "group",
        rev: false,
      },
    };
    return this.preparePost(url, params);
  }
}

/*
    get mail data
    async getDataForMailManagement(callBack, callBackError){
        let root = "http://localhost:8000/"; 
        var params = {
            params: null,
        };
        let url = root+"/api/proxy/user/search";

        const request = this.prepareGet()
        if(callBack && callBackError){

        }
    }


    normalize (type, response) {
        var data:any = [];
        var raw:any = null;

        switch (type) {
            case "ACCOUNTS_SESSIONS": {
                var accounts: any = response.accounts;
                var sessions:any = response.sessions;

                var account:any = null;
                for (var i = 0, length = accounts.length; i < length; i++) {
                    account = accounts[i];
                    account.sessionN3 = sessions[account.id].n3;
                    account.sessionN5 = sessions[account.id].n5;
                    account.sessionTotal = sessions[account.id].total;
                    data.push(account);
                }

                break;
            }
            case "ALL":
            case "SEARCH": {
                raw = response.data.rows;
                var date:any = null;
                for (var i = 0, length = raw.length; i < length; i++) {
                    date = new Date(raw[i].creationTime);
                    if (date.getFullYear() == 1970) {
                        raw[i].creationTime = raw[i].creationTime * 1000;
                    }
                    data.push(raw[i]);
                }
                break;
            }
            case "CLIENTS": {
                data = response.data.groups;
                break;
            }
            case "OWNERS": {
                data = response;
                break;
            }
            case "SESSIONS": {
                raw = response.data;
                data = {};

                var pattern1 = ".trapp03$";
                var pattern2 = ".trapp05$";
                var pattern3 = ".trapp03$|.trapp05$";
                var test1:any = null;
                var test2:any = null;
                var test3:any = null;
                var record:any = null;
                for (var i = 0, length = raw.length; i < length; i++) {
                    record = raw[i];
                    if (!(record.userId in data)) {
                        data[record.userId] = {
                            n3: 0,
                            n5: 0,
                            total: 0
                        };
                    }

                    test1 = new RegExp(pattern1, "gi");
                    test2 = new RegExp(pattern2, "gi");
                    test3 = new RegExp(pattern3, "gi");

                    if (test1.test(record.sessionId)) {
                        data[record.userId].n3++;
                    }

                    if (test2.test(record.sessionId)) {
                        data[record.userId].n5++;
                    }

                    if (test3.test(record.sessionId)) {
                        data[record.userId].total++;
                    }
                }
                break;
            }
        }

        return data;
    }
    */
